import { infiniteQueryOptions } from "@tanstack/react-query";
import type { InferResponseType } from "hono/client";
import { readJson, rpc, type QueryParams } from "./api";

export type DirectoryTour = InferResponseType<typeof rpc.api.tours.$get>["items"][number];
export type DirectoryEvent = InferResponseType<typeof rpc.api.events.$get>["items"][number];
type Page = { items: (DirectoryTour | DirectoryEvent)[]; count: number; nextCursor: string | null };
type DirectoryFilters = Omit<QueryParams<typeof rpc.api.tours.$get>, "limit" | "cursor">;
export const scheduleQuery = (kind: "tours" | "events", filters: DirectoryFilters) => infiniteQueryOptions({
  queryKey: [kind, "directory", filters],
  refetchOnWindowFocus: true,
  queryFn: ({ pageParam }): Promise<Page> => kind === "tours"
    ? readJson(rpc.api.tours.$get({ query: { ...filters, limit: 50, cursor: pageParam || undefined } }))
    : readJson(rpc.api.events.$get({ query: { ...filters, limit: 50, cursor: pageParam || undefined } })),
  initialPageParam: "",
  getNextPageParam: (last) => last.nextCursor ?? undefined,
});
